export default __webpack_public_path__ + "static/media/Icons_Download Icon.b505d527.svg";